import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { EnvironmentData } from "./types";

const initialState: EnvironmentData = {};

export const {
	name: environmentSliceName,
	actions: { setEnvironmentData },
	reducer: environmentReducer
} = createSlice({
	name: "environmentData",
	initialState,
	reducers: {
		setEnvironmentData(state, action: PayloadAction<EnvironmentData>) {
			return action.payload;
		}
	}
});
